<template>
    <div class="table-rows-selector">
        <div v-if="checkedCount > 0" class="alert alert-info p-2">
            {{ checkedCount }} / {{ checkboxesCount }} sélectionné(s)
            <button :form="form" class="btn btn-primary">Modifier les {{ checkedCount }} élements sélectionnés</button>
        </div>
        <slot :checkAll="checkAll" :uncheckAll="uncheckAll" :checkOrUncheckAll="checkOrUncheckAll" :isSelected="isSelected" :checkedCount="checkedCount" :checkboxesCount="checkboxesCount"></slot>
    </div>
</template>

<script>
export default {

    name: "TableRowsSelector",

    props: {
        form: {
            type: String,
            required: false,
        },
        checkboxName: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            checkboxes: [],
            checked: [],
        }
    },

    mounted() {
        this.checkboxes = this.$el.querySelectorAll('input[type="checkbox"][name="' + this.checkboxName + '[]"]');

        for (const cb of this.checkboxes) {
            cb.addEventListener('change', () => {
                let setOfCheckedValues = new Set(this.checked);
                if (cb.checked) {
                    setOfCheckedValues.add(cb.value);
                } else {
                    setOfCheckedValues.delete(cb.value);
                }
                this.checked = Array.from(setOfCheckedValues);
            });
        }

        // Restore list of checked checkboxes if browser reload there state (user clicked back button)
        window.addEventListener('load', () => {
            let setOfCheckedValuesOnMount = new Set(this.checked);
            for (const cb of this.checkboxes) {
                if (cb.checked) {
                    setOfCheckedValuesOnMount.add(cb.value);
                } else {
                    setOfCheckedValuesOnMount.delete(cb.value);
                }
            }
            this.checked = Array.from(setOfCheckedValuesOnMount);
        })
    },

    computed: {
        checkedValues() {
            return this.checked.join(', ');
        },

        checkedCount() {
            return this.checked.length;
        },

        checkboxesCount() {
            return this.checkboxes.length;
        },
    },

    methods: {
        isSelected(key) {
            return this.checked.includes(key);
        },

        checkAll() {
            for (const cb of this.checkboxes) {
                if (!cb.checked) {
                    cb.checked = true;
                    cb.dispatchEvent(new Event('change'));
                }
            }
        },

        uncheckAll() {
            for (const cb of this.checkboxes) {
                if (cb.checked) {
                    cb.checked = false;
                    cb.dispatchEvent(new Event('change'));
                }
            }
        },

        checkOrUncheckAll(e) {
            for (const cb of this.checkboxes) {
                if (cb.checked != e.target.checked) {
                    cb.checked = e.target.checked;
                    cb.dispatchEvent(new Event('change'));
                }
            }
        },
    },

}
</script>
